import React, { useRef, useContext, useEffect } from 'react'
import QuestionnaireFormDirectLoad from '../Direct/QuestionnaireFormDirectLoad'
import { QuestionnaireDirectProvider, QuestionnaireDirectContext } from './QuestionnaireDirectContext';
import * as Constants from '../Common/CommonConstants';
import {RenderDoneDialog} from '../Common/RenderDoneDialog';
import { getInternalDirect } from '../../services/dataService';
import bootoast from '../../bootoast/bootoast';


export default function CompInternalDirect(props) {

    const questionnaireRef = useRef(null);

    return (
        <div>
            <QuestionnaireDirectProvider>
            <div className="main-container">
                <div className="user-home-page-content">
                    <ContentArea questionnaireRef={questionnaireRef} {...props} />
                </div>
            </div>
            </QuestionnaireDirectProvider>
        </div>
    )
}

const ContentArea = ({ questionnaireRef, ...props }) => {

    const { formState, formData, doneMessage, setCompleteState, getData } = useContext(QuestionnaireDirectContext);

    useEffect(() => {    
        getData(getInternalDirect, props);
    }, []);

    if (formState === Constants.DONE_MODE || formState === Constants.SHOW_ERROR_MODE)
        return RenderDoneDialog(doneMessage);

    return <QuestionnaireFormDirectLoad ref={questionnaireRef}
        directLoadedForm={formData}
        completeButtonText={"Update and Complete"}
        handleRefresh={() => renderSuccessMessage()}
        {...props} />

}

const renderSuccessMessage = () => {
    bootoast.toast({
        position: 'top',
        message: `Updated and marked as completed sucessfully!`,
        type: 'success',
        timeout: 4
    });
}



